// extracted by mini-css-extract-plugin
module.exports = {"InnewsLink":"UHNLR","medithon":"Nv4fC","india75":"kwreA","navButton":"kyIP5","zebpay":"v1XJY","uppernewtag":"yBRCA","list":"N4kkW"};